import React from 'react'
import logo from "../images/logo.png";
import './Footer.css';
import SocialIcon from './SocialIcon';

const Footer = () => {
  return (
    <>
     <div className='footer'>
            <div className='foot-container'>
             <img src={logo} alt="" className='logo'/>
             <SocialIcon/>
             <h3 className='foot-address'>
              69 /421 Near ICICI Bank, heerapath, Mansarovar, Jaipur, Rajasthan 302020, India
            </h3>
            </div>
            
           
       </div>
    </>
  )
}

export default Footer;